import React, { useEffect } from 'react'
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar';
import SelectDropDown from '../../../components/elements/SelectDropDown';
import { VariableReport } from './VariableReport';

function FilterReport({ translate, bigTitle}) {
    const { dispatch, navigate, langLocal } = AbstructVar()
    const { state, setStateCustom, setLoad } = VariableReport();
    const Filter = (e) => {
        e.preventDefault()
        //dispatch(filterEvaluationType(state.name, state.creative_work_type_id, setLoad))
    }
    return (
        <div className='filteruser' dir={langLocal === 'ar' ? "rtl" : "ltr"}  >
            <div className='div_top_table' >
                {
                    bigTitle ? <h2 className="main_title_color" >{translate('search_filter')}</h2> :
                        <h3>{translate('search_filter')}</h3>
                }
            </div>
            <div style={{marginTop:"0px"}} className='div_filter' >
                <div style={{ marginTop: "15px" }} className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-24`} >
                    <input type='date' className={`input_filter1 ${langLocal === 'ar' ? "margin_left_25" : "margin_right_25"} `} placeholder={translate('date')} onChange={(e) => setStateCustom('date', e.target.value)} />
                </div>
                <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-24`} style={{ fontSize: "14px" }} >
                    <SelectDropDown
                        placeholder={translate('type')}
                        options={[]}
                        varr={state?.type_id}
                        setVarr={(value) => setStateCustom('type_id', value)}
                    />
                </div>
                <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-24`} style={{ fontSize: "14px" }} >
                    <SelectDropDown
                        placeholder={translate('account')}
                        options={[]}
                        varr={state?.account_id}
                        setVarr={(value) => setStateCustom('account_id', value)}
                    />
                </div>
                <button style={{marginBottom: "0px"}} className='btn_filter' onClick={Filter} >
                    {
                        state.Load ? "Loading ..." : `${translate('filter')}`
                    }
                </button>
            </div>
        </div>
    )
}

export default FilterReport